import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a1b9b45"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "PushProcessingDetail"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "order" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "订单信息", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_10 = { class: "telNum" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VanCell = _resolveComponent("VanCell")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_RestrictDialog = _resolveComponent("RestrictDialog")!
  const _component_DataDoesNotExist = _resolveComponent("DataDoesNotExist")!

  return (Object.keys($setup.detail).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_VanSwipe, {
          autoplay: 3000,
          "indicator-color": "white"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
              return (_openBlock(), _createBlock(_component_VanSwipeItem, {
                class: "my-swipe",
                key: image
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VanImage, {
                    src: image.imageUrl,
                    alt: "图片",
                    width: "100%",
                    height: "100%",
                    onClick: ($event: any) => ($setup.jumpToUrl(image.linkUrl)),
                    fit: "cover"
                  }, null, 8, ["src", "onClick"]),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(image.shopName), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_VanNoticeBar, {
          "left-icon": "volume-o",
          text: "",
          color: "red"
        }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.detail.profile), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_VanCell, {
            title: "发布地区",
            value: $setup.detail.address
          }, null, 8, ["value"]),
          _createVNode(_component_VanCell, {
            title: "发布时间",
            value: $setup.detail.refreshTime
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_VanImage, {
            src: require('@/assets/img/qq_jubao.png'),
            alt: "图片",
            width: "44px",
            height: "44px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({name:"Report",query:{id:$setup.route.query.id}})))
          }, null, 8, ["src"]),
          _createVNode(_component_VanButton, {
            color: "#19be6b",
            block: "",
            onClick: $setup.getTell
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_VanPopup, {
          class: "callDialog",
          show: $setup.isShowTel,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowTel) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, "是否拨打 " + _toDisplayString($setup.tel), 1),
            _createElementVNode("a", {
              class: "call",
              href: `tel:${$setup.tel}`
            }, "立即呼叫", 8, _hoisted_11)
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_RestrictDialog, {
          modelValue: $setup.restrictShow,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
          code: $setup.restrictCode,
          type: "single"
        }, null, 8, ["modelValue", "code"]),
        _createVNode(_component_DataDoesNotExist, {
          modelValue: $setup.isDataExist,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isDataExist) = $event))
        }, null, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}